import { AuthWrapper } from '../auth/AuthWrapper';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  return (
    <AuthWrapper>
      {children}
    </AuthWrapper>
  );
}